import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";
import myPracticeStyles from "./myPractice.module.css";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { userSelector } from "../../services/selectors/user.selectors";
import { useAppSelector } from "../../services/hooks";
import { useGetExercisesByUserGuidMutation } from "../../services/api/user.api";
import Video from "../video/video";

function MyPractice() {
  const location = useLocation();
  const navigate = useNavigate();
  const [visibleAdditionalExercises, setVisibleAdditionalExercises] = useState(2);

  const user = useAppSelector(userSelector);
  const wishPlan = user.planId === 1 ? t('PREMIUM') : t('PREMIUM_PLUS');

  const [getExercises, { data: exercises = [], isLoading, error }] =
    useGetExercisesByUserGuidMutation();

  useEffect(() => {
    if (user?.guid) {
      getExercises();
    }
  }, [user?.guid, getExercises]);

  const handleLoadMore = () => {
    setVisibleAdditionalExercises(prev => Math.min(prev + 2, exercises.length - 1));
  };


  return (
    <section dir={i18n.dir()} className={myPracticeStyles.section}>
      <h2 className={myPracticeStyles.section__title}>{t('HATRGILIM_SHELI')}</h2>
      {exercises && exercises.length > 0 && <p className={myPracticeStyles.section__text}>{t('YOUR_EXERCISE_FOR_TODAY')}</p>}
     <article className={myPracticeStyles.practice}>
        {exercises && exercises.length > 0 ? (
          <div className={myPracticeStyles.content}>
            {exercises[0].link ? (
              <div className={myPracticeStyles.video} style={{ position: 'relative' }}>
                <Video src={exercises[0].link} title={exercises[0].title} />
              </div>
            ) : (
              <div className={myPracticeStyles.video} style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: '#f0f0f0',
                color: '#666'
              }}>
                {t("NO_VIDEO_AVAILABLE")}
              </div>
            )}
            <div className={myPracticeStyles.info}>
              <h3 className={myPracticeStyles.videoTitle}>{exercises[0].title}</h3>
              <p className={myPracticeStyles.videoAbout}>{exercises[0].about}</p>
            </div>
          </div>
        ) : (
          <div className={myPracticeStyles.content}>
            <div className={myPracticeStyles.info}>
              <p className={myPracticeStyles.videoAbout}>
                {t("NO_EXERCISES_ASSIGNED_YET")}
              </p>
            </div>
          </div>
        )}
        {/* {user.planId < 3 && (
          <div className={myPracticeStyles.bottomBar}>
            <p className={myPracticeStyles.text_purple}>
              {t('UPGRADE_TO_SUBSCRIPTION')}{wishPlan} {t('RECEIVE_FULL_CONTENTS')}</p>
            <button
              className={`button ${myPracticeStyles.planBtn} hover`}
              onClick={() => {
                navigate("/profile", { replace: true, state: location });
              }}
            >
              {t('UPGRADE_TO')}{wishPlan}
            </button>
          </div>
        )} */}
      </article>
      {exercises && exercises.length > 1 && (
         <article className={myPracticeStyles.practice}>
        <h4 className={myPracticeStyles.practice__sectionTitle}>
          {t('ADDITIONAL_EXERCISES')}</h4>
        <ul className={myPracticeStyles.practice__swiper}>
          {exercises && exercises.length > 1 ? (
            exercises.slice(1, visibleAdditionalExercises + 1).map((exercise, index) => (
              <li key={exercise.id} style={{ marginBottom: '24px' }}>
                <p className={myPracticeStyles.swiper__text}>
                  {exercise.title}
                </p>
                {exercise.link ? (
                  <div className={myPracticeStyles.video} style={{ position: 'relative' }}>
                    <Video src={exercise.link} title={exercise.title} />
                  </div>
                ) : (
                  <div className={myPracticeStyles.video} style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    background: '#f0f0f0',
                    color: '#666'
                  }}>
                    {t("NO_VIDEO_AVAILABLE")}
                  </div>
                )}
                <p className={myPracticeStyles.videoAbout}>{exercise.about}</p>
              </li>
            ))
          ) : (
            <li>
              <p className={myPracticeStyles.swiper__text}>
                {t("NO_EXERCISES_ASSIGNED_YET")}
              </p>
            </li>
          )}
        </ul>
        {exercises && exercises.length > 1 && (
          visibleAdditionalExercises < exercises.length - 1 ? (
            <button
              className={`button ${myPracticeStyles.planBtn} hover`}
              onClick={handleLoadMore}
            >
              {t('MORE')}
            </button>
          ) : (
            <p style={{ 
              textAlign: 'center', 
              color: '#666', 
              marginTop: '16px',
              fontStyle: 'italic'
            }}>
              {t('ALL_EXERCISES_LOADED')}
            </p>
          )
        )}
      </article>)}
    </section>
  );
}

export default MyPractice;
